import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  httpOptions = {};
  apiURL = '';
  constructor(private http: HttpClient, envService: EnvService) {
    this.apiURL = envService.API_URL;
  }

  saveUser(token: string, type: string, options: any) {
    if (options) {
      let scopes = '';
      const opts = Object.assign({}, options);
      if (opts.scope && opts.scope.length) {
          scopes = '?';
          const optScopes = opts.scope;
          optScopes.forEach((queryParameter) => {
              scopes += queryParameter + '=1&';
          });
      }
      let apiUrl = '';
      let reqPayload = {};
      if( type === 'google') {
        apiUrl = this.apiURL + 'login_google';
        reqPayload = {'id_token': token };
      } else {
        apiUrl = this.apiURL + 'login_facebook';
        reqPayload = { 'fb_access_token': token};
      }
      return this.http.post(apiUrl, reqPayload, { withCredentials: true});
    }
  }

  getWeavyAccessToken() { 
      return this.http.get(this.apiURL + 'user/weavy/accesstoken', { withCredentials: true});
  }
}
